import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { CyCarousel } from "./CyCarousel";

interface Props {
  hasPrevious: boolean;
  hasNext: boolean;
  previous: () => void;
  next: () => void;
}

/**
 * Subtle chevrons on the left and right edge of the slides, so pages can be turned with the
 * mouse too. Only the buttons are clickable, not the whole edge, so swiping and dragging keep
 * working. Visibility (on hover, faded in on touch devices) is set by CSS, see
 * .slide-navigation-button in SongsheetCarousel.css.
 */
export function SlideNavigationButtons(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      {props.hasPrevious && (
        <button
          type="button"
          className="slide-navigation-button slide-navigation-button-previous"
          aria-label={t("carousel.slide.previousPage")}
          title={t("carousel.slide.previousPage")}
          onClick={props.previous}
          data-cy={CyCarousel.PreviousPageButton}
        >
          <FontAwesomeIcon icon={faChevronLeft} fixedWidth />
        </button>
      )}
      {props.hasNext && (
        <button
          type="button"
          className="slide-navigation-button slide-navigation-button-next"
          aria-label={t("carousel.slide.nextPage")}
          title={t("carousel.slide.nextPage")}
          onClick={props.next}
          data-cy={CyCarousel.NextPageButton}
        >
          <FontAwesomeIcon icon={faChevronRight} fixedWidth />
        </button>
      )}
    </>
  );
}
